import React from 'react';
import { Box } from '@mui/material';
import { ConfirmationCardSessionInfo, ConfirmationCardSessionInfoProps } from './session-info.component';
import { Button, Alert } from '@uplift/ui-v2';
import { ProviderInfoCard, ProviderInfoCardProps } from './provider-info-card.component';


export type ProviderConfirmationCardProps = {
  provider: ProviderInfoCardProps['provider'];
  appointment: ConfirmationCardSessionInfoProps;
  onConfirm: () => void;
  isLoading?: boolean;
  error?: string;
  roleLabel: string;
};


export const ProviderConfirmationCard: React.FC<ProviderConfirmationCardProps> = (props) => {
  return (
    <ProviderInfoCard
      provider={props.provider}
      actions={(
        <>
          <Button loading={props.isLoading} size="large" variant="contained" color="secondary" fullWidth onClick={props.onConfirm}>Confirm New {props.roleLabel}</Button>
          {props.error && (
            <Box mt={2}>
              <Alert severity="error">{props.error}</Alert>
            </Box>
          )}
        </>
      )}
    >
      <ConfirmationCardSessionInfo {...props.appointment} />
    </ProviderInfoCard>
  );
};
